export default __webpack_public_path__ + "static/media/indexx-logo-v3-dark.bcaec863.svg";